import { useMutation } from "react-query";
import { activitySearch } from "../../services";
import usePopup from "../../../hooks/usePopup";

const useActivitySearch = () => {
    const {showSnackbar} = usePopup()
    return useMutation(activitySearch,{
        onSuccess:(result)=>{
           if(result.responseIndicator == "fail"){
            showSnackbar({
                message:result.responseMessage || "Something went wrong !",
                open:true,
                variant:"warning",
                duration:4000
            })
           }
        },
        onError:(e:any)=>{
            showSnackbar({
                message:e?.response?.data?.responseMessage || "Error !",
                open:true,
                variant:"error",
                duration:4000
            })
        }
    })
};

export default useActivitySearch